module.exports = __webpack_public_path__ + "img/9788936456450.1bcf212d.jpg";